import { useCallback, useEffect, useState } from "react";
import { http, formatApiError, getUserLabels } from "../../lib/api";
import { toast } from "../../lib/notify";

// CrudTable durumu: liste, form, alan doğrulama ve kaydet/sil işlemleri
export function useCrud({ resource, fields, defaults, listParams }) {
  const [items, setItems] = useState([]);
  const [editing, setEditing] = useState(null); // id being edited or 'new'
  const [form, setForm] = useState(defaults);
  const [errors, setErrors] = useState({});
  const [userLabels, setUserLabels] = useState({});
  useEffect(() => { getUserLabels().then(setUserLabels); }, []);

  const listKey = JSON.stringify(listParams ?? null);
  const load = useCallback(() => http.get(`/${resource}`, { params: JSON.parse(listKey) ?? undefined }).then((r) => setItems(r.data)), [resource, listKey]);
  useEffect(() => { load(); }, [load]);

  const optsOf = (f) => (typeof f.options === "function" ? f.options(form) : f.options) || [];

  const updateField = (f, v) => {
    let next = { ...form, [f.key]: v };
    if (f.onChange) next = f.onChange(v, next) || next;
    setForm(next);
    if (f.validate) setErrors((e) => ({ ...e, [f.key]: f.validate(next[f.key], next, items, editing) }));
  };

  const runValidations = (f0, editId) => {
    const errs = {};
    fields.forEach((f) => { if (f.validate) errs[f.key] = f.validate(f0[f.key], f0, items, editId); });
    setErrors(errs);
    return Object.values(errs).some(Boolean);
  };

  const startNew = () => { setForm(defaults); setEditing("new"); setErrors({}); };
  const startEdit = (it) => { const f0 = { ...defaults, ...it }; setForm(f0); setEditing(it.id); runValidations(f0, it.id); };
  const cancel = () => { setEditing(null); setForm(defaults); setErrors({}); };

  const submit = async (e) => {
    e.preventDefault();
    if (runValidations(form, editing)) { toast.error("Formda hatalı alanlar var — kırmızı uyarıları düzeltin."); return; }
    try {
      const payload = {};
      fields.forEach((f) => {
        let v = form[f.key];
        if (f.type === "number") v = parseFloat(String(v).replace(",", "."));
        payload[f.key] = v;
      });
      if (editing === "new") await http.post(`/${resource}`, payload);
      else await http.put(`/${resource}/${editing}`, payload);
      toast.success("Kaydedildi");
      cancel();
      await load();
    } catch (err) { toast.error(formatApiError(err)); }
  };

  const remove = async (id) => {
    if (!window.confirm("Silinsin mi?")) return;
    try { await http.delete(`/${resource}/${id}`); toast.success("Silindi"); await load(); }
    catch (err) { toast.error(formatApiError(err)); }
  };

  return { items, editing, form, setForm, errors, userLabels, optsOf, updateField, startNew, startEdit, cancel, submit, remove };
}
